module.exports = __webpack_public_path__ + "static/img/ios.30935fce.png";